let csrfToken = null;
let isFetchingToken = false;
let tokenFetchPromise = null;

function fetchCsrfToken() {
    if (isFetchingToken && tokenFetchPromise) {
        return tokenFetchPromise;
    }
    if (csrfToken) {
        return Promise.resolve(csrfToken);
    }

    isFetchingToken = true;

    tokenFetchPromise = fetch('/get_token.php')
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error fetching token! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            if (data.csrf_token) {
                csrfToken = data.csrf_token;
                isFetchingToken = false;
                return csrfToken;
            } else {
                throw new Error('CSRF token not found in response.');
            }
        })
        .catch(error => {
            console.error('Failed to fetch CSRF token:', error);
            //formStatus.innerHTML = '<div class="alert alert-danger">Security token error. Cannot submit form.</div>';
            isFetchingToken = false;
            throw error;
        });
    return tokenFetchPromise;
}

function initializeContactForm(token) {
    const contactForm = document.getElementById('contact-form');
    const formFieldsContainer = document.getElementById('form-fields-container');
    const formStatus = document.getElementById('form-status');

    if (!contactForm || !formFieldsContainer || !formStatus) {
        console.error('Form elements not found after template load. Check IDs.');
        return;
    }

    if (!contactForm.querySelector('input[name="csrf_token"]')) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'csrf_token';
        hiddenInput.value = token;
        contactForm.appendChild(hiddenInput);
    }

    contactForm.addEventListener('submit', function (event) {
        event.preventDefault();
        formStatus.innerHTML = '<div class="alert alert-info">Sending message, please wait...</div>';
        formStatus.style.display = 'block';
        formFieldsContainer.style.display = 'none';
        const formData = new FormData(contactForm);

        fetch('mail.php', {
            method: 'POST',
            body: formData
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().catch(() => {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }).then(errorData => {
                        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    formStatus.innerHTML = `<div class="alert alert-success">${data.message}</div>`;
                } else {
                    formStatus.innerHTML = `<div class="alert alert-danger">${data.message || 'An error occurred.'}</div>`;
                    formFieldsContainer.style.display = 'block';
                }
            })
            .catch(error => {
                console.error('Form submission fetch error:', error);
                formStatus.innerHTML = `<div class="alert alert-danger">${error.message || 'An unexpected network error occurred. Please try again.'}</div>`;
                formFieldsContainer.style.display = 'block';
            });
    });
}

document.addEventListener('templateLoaded', function (event) {
    if (event.detail.file === 'template-index-form.html' || event.detail.file === 'template-page-form.html') {

        fetchCsrfToken()
            .then(token => {
                initializeContactForm(token);
            })
            .catch(error => {
                console.error("Initialization failed because token fetch failed.");
                const formStatus = document.getElementById('form-status');
                if (formStatus) {
                    formStatus.innerHTML = '<div class="alert alert-danger">Failed to load security token. Form cannot be submitted.</div>';
                    formStatus.style.display = 'block';
                }
            });
    }
});

fetchCsrfToken();